<style>
.item-list-only-wrapper {
  padding: 8px 0;
}
</style>

<style>
/* Global override for the Item List el-dialog rounded corners */
.item-list-dialog .el-dialog {
  border-radius: 20px !important;
  overflow: hidden;
}
.item-list-dialog .el-dialog__header {
  border-radius: 20px 20px 0 0;
}
</style>

<template>
  <div class="row justify-content-center item-list-only-wrapper">
    <!-- Search and Filter Section -->
    <div class="col-sm-11 mb-3">
      <div class="row align-items-center mb-3">
        <div class="col-10">
          <div class="global-searchbar laurenGreen">
            <form class="base-form" @submit.prevent>
              <div class="input-group">
                <div class="input-group-text">
                  <img src="@/assets/images/system/tools.svg" />
                </div>
                <input
                  type="search"
                  name="globalSearch"
                  class="form-control"
                  placeholder="Search items..."
                  v-model="itemSearchQuery"
                />
                <button type="submit" name="btnSearch" class="btn btn-lauren-green">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="col-2 d-flex">
          <ul class="search-option-menu mb-0 ps-0 list-unstyled d-flex align-items-center">
            <li class="nav-item sorting me-3">
              <input
                type="checkbox"
                class="sorting-check"
                id="btn-sorting-popup"
                autocomplete="off"
                v-model="sortOrderAsc"
              />
              <label class="btn btn-sorting mb-0" for="btn-sorting-popup"
                ><span class="sr-only">Sort</span>
              </label>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link circleNav" @click.prevent="goToAddItem" title="Add New Item">
                <i class="fa fa-plus"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Filters -->
      <div class="global-filter-form-popup d-flex justify-content-start">
        <div class="base-form d-flex flex-row gap-2">
          <select class="form-select _3d-input" v-model="searchCategory" style="width: 306px;">
            <option value="">Categories</option>

            <option
              v-for="cat in categories"
              :key="cat.id"
              :value="cat.type"
            >
              {{ cat.type }}
            </option>
          </select>

          <button
            type="button"
            class="btn btn-white _3d-input _sq"
            :class="{ 'active-filter': filterType === 'parts' }"
            @click="setFilter('parts')"
          >
            <i class="fa fa-cog"></i>
          </button>

          <button
            type="button"
            class="btn btn-white _3d-input _sq"
            :class="{ 'active-filter': filterType === 'service' }"
            @click="setFilter('service')"
          >
            <i class="fas fa-running"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Items List -->
    <div
      class="col-sm-11 mt-2"
      v-for="(item, index) in filteredItems"
      :key="index"
    >
      <div
        class="card card-horizontal-list laurenGreen"
        :class="{
          'border-success': selectedItemsForBorder.includes(item.item_no)
        }"
      >
        <div
          class="card-body"
          @click="addToRecentItems(item.item_no)"
        >
          <div class="card-content">
            <span class="card-count">{{ index + 1 }}.</span>

            <ul class="label-list">
              <li class="list-title">
                <label>C:</label>
                <span class="list-text">{{ item.category_type }}</span>
              </li>

              <li class="sub-title">
                <label>I:</label>
                <span class="list-text">{{ item.name }}</span>
              </li>

              <li>
                <label>I.No:</label>
                <span class="list-text">{{ item.item_no }}</span>
              </li>

              <li class="mt-2">
                <label>D:</label>
                <span class="list-text">{{ item.description }}</span>
              </li>
            </ul>
          </div>

          <div class="content-option">
            <ul class="cmn-vrList">
              <li v-if="item.type === 'parts'">
                <a href="#"><i class="fa fa-cog"></i></a>
              </li>

              <li v-if="item.type === 'service'">
                <a href="#"><i class="fas fa-running"></i></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="card-footer has-action">
          <div class="ellipsis-dropdown dropdown">
            <button
              class="btn dropdown-toggle no-caret"
              type="button"
              data-bs-toggle="dropdown"
            >
              <i class="fas fa-ellipsis-v"></i>
            </button>

            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item edit" href="#">
                  <i class="fa fa-edit"></i>
                </a>
              </li>

              <li>
                <a
                  class="dropdown-item delete"
                  @click.stop="deleteItem(item.id, item.item_no)"
                  href="#"
                >
                  <i class="fa fa-times"></i>
                </a>
              </li>
            </ul>
          </div>

          <div class="footer-list-wraper">
            <ul class="footer-list">
              <li>Quantity</li>
              <li class="count">
                {{ parseInt(item.quantity) }}
              </li>
            </ul>

            <ul class="footer-list highlight">
              <li>Rate</li>
              <li class="count">
                {{$auth.user?.currency}}
                {{ parseFloat(item.unit_price).toFixed(2) }}
              </li>
            </ul>

            <ul class="footer-list _big">
              <li>Price</li>
              <li class="count">
                {{$auth.user?.currency}}
                {{ (item.unit_price * item.quantity).toFixed(2) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "ItemListOnlyForInvoice",

  data() {
    return {
      loadingInstance: null,
      item_server_data: [],
      categories: [],
      selectedItems: [],
      selectedItemsForBorder: [],
      itemSearchQuery: "",
      debouncedSearchQuery: "",
      searchCategory: "",
      filterType: "all",
      sortOrderAsc: true,
    };
  },

  mounted() {
    this.runMountedFunctions();
  },

  watch: {
    popupOpenEvent(newValue) {
      if (newValue) {
        this.getData();
      }
    },

    itemSearchQuery: _.debounce(function (newVal) {
      this.debouncedSearchQuery = newVal;
    }, 500),
  },

  computed: {
    filteredItems() {
      let filtered = this.item_server_data.filter((item) => {

        const searchTerm =
          (this.debouncedSearchQuery || "").toLowerCase();

        const matchesSearch =
          (item.name || "").toLowerCase().includes(searchTerm) ||
          (item.item_no || "").toLowerCase().includes(searchTerm) ||
          (item.description || "").toLowerCase().includes(searchTerm) ||
          (item.category_type || "").toLowerCase().includes(searchTerm) ||
          (item.client_name || "").toLowerCase().includes(searchTerm) ||
          (item.business_name || "").toLowerCase().includes(searchTerm);

        const matchesCategory = this.searchCategory
          ? item.category_type === this.searchCategory
          : true;

        const matchesType =
          this.filterType !== "all"
            ? item.type === this.filterType
            : true;

        return matchesSearch && matchesCategory && matchesType;
      });

      filtered.sort((a, b) => {
        const nameA = (a.name || "").toLowerCase();
        const nameB = (b.name || "").toLowerCase();
        if (nameA < nameB) return this.sortOrderAsc ? -1 : 1;
        if (nameA > nameB) return this.sortOrderAsc ? 1 : -1;
        return 0;
      });

      return filtered;
    },
  },

  methods: {
    resetData() {
      this.selectedItemsForBorder = [];
      this.itemSearchQuery = "";
      this.searchCategory = "";
      this.filterType = "all";
    },

    runMountedFunctions() {
      this.$store
        .dispatch("item/fetchCategory")
        .then((res) => {
          this.categories = res;
          this.getData();
        });
    },

    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0,0,0,0.7)",
        fullscreen: true,
      });
    },

    hideLoading() {
      this.loadingInstance.close();
    },

    getData() {
      this.showLoading();

      this.$store
        .dispatch("item/getList", this.form || {})
        .then((res) => {

          // Unwrap only a raw axios response. The API envelope itself has a top-level
          // `data` key, so a plain truthiness check on res.data grabbed the payload
          // array instead of the envelope and every list rendered empty.
          const apiRes = res?.data?.status !== undefined ? res.data : res;

          if (apiRes.status === "1") {
            this.item_server_data = apiRes.response;
          } else {

            const errorMsg =
              apiRes.message?.length > 0
                ? Array.isArray(apiRes.message)
                  ? apiRes.message.join("\n")
                  : apiRes.message
                : "Something went wrong.";

            this.$toast.error(errorMsg);
            throw new Error(errorMsg);
          }
        })
        .catch(() => {
          this.item_server_data = [];
          this.$toast.error("Something went wrong.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    deleteItem(item_id, item_no = "") {

      this.showLoading();

      this.removeItemFromRecentList(item_no);

      this.$store
        .dispatch("item/deleteItem", { item_id })
        .then((res) => {

          if (res.status == 1) {
            this.$toast.success("Delete data Successful.");
          } else {
            throw new Error(res);
          }

        })
        .catch(() => {
          this.$toast.error("Something went wrong.");
        })
        .finally(() => {
          this.getData();
        });
    },

    addToRecentItems(selectedItemsNumber) {
      const index = this.selectedItemsForBorder.indexOf(selectedItemsNumber);
      if (index !== -1) {
        // Already selected — remove it
        this.selectedItemsForBorder.splice(index, 1);
        this.$store.commit(
          "item/removeFromRecentItemsInvoice",
          selectedItemsNumber
        );
      } else {
        // Not selected — add it
        this.selectedItemsForBorder.push(selectedItemsNumber);
        this.$store.commit(
          "item/addToRecentItems",
          selectedItemsNumber
        );
      }
    },

    setFilter(type) {
      if (this.filterType === type) {
        this.filterType = "all";
      } else {
        this.filterType = type;
      }
    },
    goToAddItem() {
      // Remove any lingering Bootstrap modal classes and backdrops
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());

      // Navigate to the add-item route
      this.$router.push({ name: 'add-item' });
    },
  },
};
</script>